import { render, staticRenderFns } from "./SuperAdminSetting.vue?vue&type=template&id=781e2a53"
import script from "./SuperAdminSetting.vue?vue&type=script&lang=js"
export * from "./SuperAdminSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports